import { regionalTokens } from "./access-client";
import { forgetChatClients } from "./chats/client";
import { forgetChatRecordings } from "./recordings/chat-recordings";
import { queryClient } from "./query-client";

/**
 * Everything the browser holds on the strength of belonging to the firm: the regional token, the
 * running chat clients and every cached read. Dropped together, as sign-out drops them, so nothing
 * of the firm is shown to (or kept for) someone who is no longer in it. The session itself stays:
 * they are still signed in, to no firm.
 */
export function forgetFirm(): void {
  regionalTokens.clear();
  forgetChatClients();
  forgetChatRecordings();
  queryClient.clear();
}
